// extracted by mini-css-extract-plugin
export var actionSelect = "_t2-0";